import { MapPin, Clock, Phone, Star, ArrowUpRight } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contato"
      data-testid="contact-section"
      className="relative bg-cream py-24 md:py-36 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-14 items-center">
        <div className="md:col-span-7 reveal-left">
          <div className="eyebrow text-gold mb-6 reveal-eyebrow">Venha nos visitar</div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-[92px] leading-[1.02] tracking-[-0.03em] text-espresso max-w-[14ch] reveal-clip">
            Fica fácil de achar — <em className="italic text-gold">o café já está pronto.</em>
          </h2>
          <p className="mt-8 text-espresso/75 text-base md:text-lg leading-relaxed max-w-2xl">
            Estamos na Praça Getúlio Vargas, 367, atrás da Igreja Matriz de
            Alfenas. De segunda a sexta das 8h às 18h, e aos sábados das 9h às
            18h.
          </p>
          <p className="mt-4 text-espresso/75 text-base md:text-lg leading-relaxed max-w-2xl">
            Prefere falar antes? Chame pelo WhatsApp. A gente responde com o
            aroma do café fresquinho.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="https://wa.me/5535999516948?text=Ol%C3%A1%21%20Gostaria%20de%20saber%20mais%20sobre%20o%20Emp%C3%B3rio%20do%20Caf%C3%A9."
              target="_blank"
              rel="noreferrer"
              data-testid="contact-cta-whatsapp"
              className="btn-gold pulse-ring"
            >
              Falar no WhatsApp <ArrowUpRight size={16} />
            </a>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Pra%C3%A7a+Get%C3%BAlio+Vargas+367+Alfenas+MG"
              target="_blank"
              rel="noreferrer"
              data-testid="contact-cta-maps"
              className="btn-ghost !text-espresso !border-espresso/25 hover:!bg-espresso/5"
            >
              <MapPin size={16} /> Ver no mapa
            </a>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl">
            {[
              { n: "4.8", l: "Nota Google" },
              { n: "118", l: "Avaliações" },
              { n: "50+", l: "Tipos de café" },
              { n: "2012", l: "Desde" },
            ].map((b, i) => (
              <div key={i} className="border-t border-espresso/15 pt-4">
                <div className="font-display text-3xl md:text-4xl text-espresso leading-none">
                  {b.n}
                </div>
                <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-espresso/55 mt-2">
                  {b.l}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="md:col-span-5 reveal-right">
          <div className="relative rounded-[14px] overflow-hidden border border-espresso/10 bg-espresso text-cream">
            <img
              src="/visita-v2.avif"
              alt="Fachada do Empório do Café"
              className="w-full h-[320px] object-cover opacity-85"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-espresso via-espresso/40 to-transparent" />
            <div className="relative p-7 md:p-9 space-y-5">
              <Info icon={MapPin} title="Endereço">
                Praça Getúlio Vargas, 367 — Centro<br />
                Alfenas / MG · Atrás da Igreja Matriz
              </Info>
              <Info icon={Clock} title="Horários">
                Seg–Sex · 8h às 18h<br />
                Sábados · 9h às 18h
              </Info>
              <Info icon={Phone} title="WhatsApp">
                (35) 99951-6948
              </Info>
              <Info icon={Star} title="Reputação">
                4.8 no Google · 118 avaliações
              </Info>
            </div>
          </div>

          <ul className="mt-6 grid grid-cols-1 gap-3">
            {[
              "Cafés especiais moídos na hora",
              "Produtos premiados no Brasil e exterior",
              "Boutique de café em Alfenas / MG",
            ].map((t, i) => (
              <li
                key={i}
                className="flex items-center gap-3 px-5 py-3 rounded-full bg-cream-50 border border-espresso/10 font-mono text-[11px] tracking-[0.2em] uppercase text-espresso/75"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-gold" />
                {t}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

function Info({ icon: Icon, title, children }) {
  return (
    <div className="flex items-start gap-4">
      <div className="shrink-0 w-10 h-10 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center text-gold">
        <Icon size={16} />
      </div>
      <div>
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-cream/55">
          {title}
        </div>
        <div className="font-body text-sm md:text-[15px] text-cream/95 leading-relaxed mt-1">
          {children}
        </div>
      </div>
    </div>
  );
}
